import { useAuth } from "../features/auth/AuthContext.jsx";

// Shows when Firebase env isn't filled yet, so the app degrades gracefully
// instead of throwing. Remove once .env is configured (it self-hides).
export default function ConfigBanner() {
  const { configured } = useAuth();
  if (configured) return null;
  return (
    <div className="container" style={{ marginTop: 16 }}>
      <div className="banner">
        Firebase isn't configured yet. Copy <code>frontend/.env.example</code> to{" "}
        <code>frontend/.env</code> and add your project keys to enable sign-in,
        claiming and saving. The UI below is fully interactive for preview.
      </div>
    </div>
  );
}
